module.exports = __webpack_public_path__ + "img/Fondo_Web_optimizado.b0dbddf1.svg";